module.exports = __webpack_public_path__ + "static/media/resetPasswordBg.c4cbc99b.png";